import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests if available
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Authentication APIs
export const authAPI = {
  login: async (email, password) => {
    const response = await apiClient.post('/auth/login', { email, password });
    return response.data;
  },
  logout: async () => {
    const response = await apiClient.post('/auth/logout');
    return response.data;
  },
  verify: async () => {
    const response = await apiClient.get('/auth/verify');
    return response.data;
  },
  changePassword: async (currentPassword, newPassword) => {
    const response = await apiClient.put('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword
    });
    return response.data;
  }
};

// Gallery APIs
export const galleryAPI = {
  getCategories: async () => {
    const response = await apiClient.get('/categories');
    return response.data;
  },
  getImages: async (category = 'all') => {
    const response = await apiClient.get('/gallery/images', {
      params: { category }
    });
    return response.data;
  },
  uploadImage: async (formData) => {
    const response = await apiClient.post('/gallery/images', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  },
  deleteImage: async (imageId) => {
    const response = await apiClient.delete(`/gallery/images/${imageId}`);
    return response.data;
  }
};

// Photographer APIs
export const photographerAPI = {
  getInfo: async () => {
    const response = await apiClient.get('/photographer');
    return response.data;
  },
  updateInfo: async (data) => {
    const response = await apiClient.put('/photographer', data);
    return response.data;
  }
};

// Contact APIs
export const contactAPI = {
  submit: async (formData) => {
    const response = await apiClient.post('/contact', formData);
    return response.data;
  }
};

export default apiClient;
